import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensScanForm from 'screens/Scan/Form/ScreensScanForm';
import ScreensWatchSourcesForm from './Form/ScreensWatchSourcesForm';

function ScreensScan() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RoutePrivate
            element={ScreensScanForm}
            requiredPermission="sources.list"
          />
        }
      />
      <Route
        path="/watch-sources"
        element={
          <RoutePrivate
            element={ScreensWatchSourcesForm}
            requiredPermission="sources.list"
          />
        }
      />
    </Routes>
  );
}

export default ScreensScan;
